<mat-sidenav-container class="app-container">
  <mat-sidenav #sidenav mode="over" position="end" class="app-sidenav" aria-label="Menu de navegação">
    <nav class="mobile-nav">
      <a *ngIf="!(auth.hasRole('ESTABLISHMENT') || auth.hasRole('EMPLOYEE')) && false" mat-button routerLink="/comprar" (click)="sidenav.close()">Comprar</a>
      <a mat-button routerLink="/faq" (click)="sidenav.close()">FAQ</a>

      <ng-container *ngIf="auth.user as user; else mobileLogin">
        <a *ngIf="auth.hasRole('CLIENT')" mat-button routerLink="/meus-cupons" (click)="sidenav.close()">
          <mat-icon>local_offer</mat-icon>
          Cupons
        </a>
        <a *ngIf="auth.hasRole('CLIENT')" mat-button routerLink="/area-cliente/pedidos" (click)="sidenav.close()">
          <mat-icon>receipt_long</mat-icon>
          Pedidos
        </a>
        <a *ngIf="auth.hasRole('ESTABLISHMENT') || auth.hasRole('EMPLOYEE')" mat-button routerLink="/area-estabelecimento/validar" (click)="sidenav.close()">
          <mat-icon>qr_code_scanner</mat-icon>
          Validar Cupons
        </a>
        <a *ngIf="auth.hasRole('ESTABLISHMENT')" mat-button routerLink="/area-estabelecimento/funcionarios" (click)="sidenav.close()">
          <mat-icon>group</mat-icon>
          Funcionários
        </a>
        <a mat-button [routerLink]="auth.hasRole('CLIENT') ? '/area-cliente/perfil' : (auth.hasRole('ESTABLISHMENT') ? '/area-estabelecimento/perfil' : '/area-funcionario/alterar-senha')" (click)="sidenav.close()">
          <mat-icon>account_circle</mat-icon>
          {{ user.name || 'Meu perfil' }}
        </a>
        <button mat-stroked-button (click)="sidenav.close(); logout()">
          <mat-icon>logout</mat-icon>
          Sair
        </button>
      </ng-container>
      <ng-template #mobileLogin>
        <a mat-button routerLink="/cadastro" (click)="sidenav.close()">Criar conta</a>
        <a mat-button routerLink="/credenciamento" (click)="sidenav.close()">Credenciamento</a>
        <a mat-stroked-button routerLink="/login" (click)="sidenav.close()">Entrar</a>
      </ng-template>
    </nav>
  </mat-sidenav>

  <mat-toolbar color="primary" class="toolbar" role="navigation">
    <!-- Hamburger visible only on small screens -->
    <button class="menu-button" mat-icon-button aria-label="Abrir menu" (click)="sidenav.toggle()">
      <img src="assets/SVG/Menu-Hamburguer.svg" alt="Menu" />
    </button>

    <a class="logo" routerLink="/" aria-label="Ir para a Home">
      <img src="assets/SVG/logo/logo-amarela.svg" alt="Leva Dois" />
      <span class="sr-only">Leva Dois</span>
    </a>
    <span class="spacer"></span>

    <!-- Desktop links -->
    <div class="desktop-links">
      <a *ngIf="!(auth.hasRole('ESTABLISHMENT') || auth.hasRole('EMPLOYEE')) && false" mat-button routerLink="/comprar">Comprar</a>
      <a mat-button routerLink="/faq">FAQ</a>

      <ng-container *ngIf="auth.user as user; else loginBtn">
        <a *ngIf="auth.hasRole('CLIENT')" mat-button routerLink="/meus-cupons" aria-label="Meus cupons">
          <mat-icon>local_offer</mat-icon>
          Cupons
        </a>
        <a *ngIf="auth.hasRole('CLIENT')" mat-button routerLink="/area-cliente/pedidos" aria-label="Meus pedidos">
          <mat-icon>receipt_long</mat-icon>
          Pedidos
        </a>
        <a *ngIf="auth.hasRole('ESTABLISHMENT') || auth.hasRole('EMPLOYEE')" mat-button routerLink="/area-estabelecimento/validar" aria-label="Validar cupons">
          <mat-icon>qr_code_scanner</mat-icon>
          Validar Cupons
        </a>
        <a *ngIf="auth.hasRole('ESTABLISHMENT')" mat-button routerLink="/area-estabelecimento/funcionarios" aria-label="Funcionários">
          <mat-icon>group</mat-icon>
          Funcionários
        </a>
        <button mat-button [routerLink]="auth.hasRole('CLIENT') ? '/area-cliente/perfil' : (auth.hasRole('ESTABLISHMENT') ? '/area-estabelecimento/perfil' : '/area-funcionario/alterar-senha')" aria-label="Perfil">
          <mat-icon>account_circle</mat-icon>
          {{ user.name || 'Meu perfil' }}
        </button>
        <button mat-stroked-button (click)="logout()" aria-label="Sair">
          <mat-icon>logout</mat-icon>
          Sair
        </button>
      </ng-container>
      <ng-template #loginBtn>
        <a mat-button routerLink="/cadastro" aria-label="Criar conta (Cliente)">Criar conta</a>
        <a mat-button routerLink="/credenciamento" aria-label="Credenciamento (Empresa)">Credenciamento</a>
        <a mat-stroked-button routerLink="/login">Entrar</a>
      </ng-template>
    </div>
  </mat-toolbar>

  <main class="content">
    <router-outlet></router-outlet>
  </main>
</mat-sidenav-container>

<footer class="app-footer" role="contentinfo">
  <div class="app-footer__inner">
    <span>Leva Dois</span>
    <span class="spacer"></span>
    <a routerLink="/faq">FAQ</a>
    <a routerLink="/termos">Termos</a>
    <a routerLink="/privacidade">Privacidade</a>
  </div>
</footer>
